import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { getProducts } from '../../products';
import { getStep, nextStep } from '../../steps';
import { updateOrder } from '../../order';
import Button from '../../../../ui/Button';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Positions from './position/Positions';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/PositionStep.scss';
import Sticky from 'react-stickynode';
import ValidationErrors from '../../components/ValidationErrors';
import {withRouter} from "react-router-dom";
import {getAdditions} from "../../../app/additions";

@injectIntl
export class PositionStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
        order: ImmutablePropTypes.map,
        products: ImmutablePropTypes.map,
        services: ImmutablePropTypes.map,
        step: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.fetchProducts();
    }

    componentDidUpdate(prevProps) {
        const { order } = this.props;
        const prevOrder = prevProps.order;

        // Refetch products if service, region, or location changed
        if (
            order.get('service') !== prevOrder.get('service') ||
            order.get('region') !== prevOrder.get('region') ||
            order.get('location') !== prevOrder.get('location')
        ) {
            this.fetchProducts();
        }
    }

    fetchProducts = () => {
        const { order, dispatch } = this.props;

        const params = {
            service: order.get('service'),
            region: order.get('region'),
            location: order.get('location'),
        };

        if (params.service && params.region) {
            dispatch(getProducts(params));
        }
    }

    handleUpdateOrder = (order) => {
        const {dispatch} = this.props;
        dispatch(updateOrder(order));
    }

    handleNextStep = () => {
        const { step, dispatch, order } = this.props;
        dispatch(getAdditions({order}));
        dispatch(nextStep(step));
    }

    // TODO: Needs to be improved! And should be in a seperate component
    renderHeader = () => {
        const { services, order } = this.props;
        const currentService = services.get(order.get('service'));
        let multiHeader;

        if (!currentService) return null;

        let list = [];
        if (currentService.get('mode') === 'service.mode.single') {
            list = [currentService];
        } else {
            list = ['service.delivery', 'service.pickup']
                .map(alias => services.find(s => s.get('alias') === alias));
            multiHeader = (
                <div>
                    <h1><FormattedMessage id={`service.${currentService.get('alias').split('.')[1]}`} /></h1>
                    <h2><FormattedMessage id={`frontend.form_position.hint.${currentService.get('alias').split('.')[1]}`} /></h2>
                </div>
            );
        }

        const result = list.map(service => {
            const alias = service ? service.get('alias') : null;
            const img = service ? service.getIn(['image', 'path']) : null;
            const serviceType = service ? service.get('alias').split('.')[1] : null;

            return !alias ? null : (
                <div className={styles.header} key={alias}>
                    <h1><FormattedMessage id={`${alias}`} /></h1>
                    <h4>
                        <FormattedMessage
                            id={`frontend.form_selector_service.hint.${serviceType}`}
                        />
                    </h4>
                    <img className={styles.image} role='presentation' src={`/${img}`} />
                </div>
            );
        });

        return (
            <div className={styles.headerContainer}>
                {multiHeader}
                <div className={styles.serviceHeaderContainer}>
                    {result}
                </div>
            </div>
        );
    }

    render() {
        const { step, products, services, order } = this.props;

        return (
            <div className={styles.container}>

                <div className={styles.service}>
                    {this.renderHeader()}
                </div>

                <ValidationErrors errors={step.get('errors')} status={step.get('state')}>
                    <FormattedMessage id='frontend.form_position.validation' />
                </ValidationErrors>
                <Sticky top='#page-header' innerZ={98}>
                    <div className={styles.actions}>
                        <Button
                            block
                            disabled={!order.get('positions').count()}
                            emphasis='primary'
                            onClick={this.handleNextStep}
                        >
                            <FormattedMessage id='frontend.form_position.button.continue' />
                        </Button>
                    </div>
                </Sticky>
                <div className={styles.content}>
                    <Positions
                        positions={products}
                        services={services}
                        order={order}
                        handleUpdateOrder={this.handleUpdateOrder}
                        isEditable
                    />
                </div>

                <div className={styles.actions}>
                    <Button
                        block
                        disabled={!order.get('positions').count()}
                        emphasis='primary'
                        onClick={this.handleNextStep}
                    >
                        <FormattedMessage id='frontend.form_position.button.continue' />
                    </Button>
                </div>
            </div>
        );
    }
}

export default withRouter(connect((state) => ({
    products: state.products,
    services: state.services,
    order: state.order,
    step: getStep(state, 'position'),
}))(PositionStep));
